/* istanbul ignore file */
import React from 'react';
import { Paper, Typography } from '@mui/material';
import { pageContentSx } from 'framework/ui/layout';

type CreatePageLayoutProps = {
  children?: React.ReactNode | React.ReactNode[];
  id?: string;
};

const OneStopCreatePageLayout = ({ children, id }: CreatePageLayoutProps) => {
  return (
    <Paper
      sx={{
        ...pageContentSx,
        border: '1px solid',
        borderColor: 'border.separator',
        '& #request-IM01 div:empty': {
          display: 'none',
        },
      }}
    >
      <Typography variant="h1" color="brand" mb={4}>
        One Stop: Create Request
      </Typography>
      <div id={`request-${id}`}>{children}</div>
    </Paper>
  );
};

export default OneStopCreatePageLayout;
